<div class="flex flex-col gap-6">
  <div
    class="px-4 py-2 text-general-title text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.quotation' | translate }}
  </div>
  <div class="px-4">
    <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary">
      @for (cotizacionData of cotizacion; track cotizacionData) {
        @if (!cotizacionData.disguise) {
          <div
            class="flex flex-col gap-1"
            [ngClass]="{
              'col-span-full': cotizacionData.isHighlight,
            }"
          >
            <div class="font-bold">
              {{
                cotizacionData.replacementName
                  ? cotizacionData.replacementName
                  : cotizacionData.key
              }}:
            </div>
            {{
              cotizacionData.isMoney
                ? (cotizacionData.value | currency: 'MXN' : 'symbol' : '1.0-0')
                : cotizacionData.isPercentage
                  ? (cotizacionData.value * 100 | number: '1.0-2') + '%'
                  : cotizacionData.value
            }}
          </div>
        }
      }
    </div>
  </div>

  <div
    class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.debtor' | translate }}
  </div>
  <div class="px-4">
    <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary">
      @for (deudorData of deudor; track deudorData) {
        @if (!deudorData.disguise) {
          <div
            class="flex flex-col gap-1"
            [ngClass]="{
              'col-span-full': deudorData.isHighlight,
            }"
          >
            <div class="font-bold">
              {{ deudorData.replacementName ? deudorData.replacementName : deudorData.key }}:
            </div>
            <div class="font-medium">
              {{
                deudorData.isMoney
                  ? (deudorData.value | currency: 'MXN' : 'symbol' : '1.0-0')
                  : deudorData.isPercentage
                    ? (deudorData.value * 100 | number: '1.0-2') + '%'
                    : deudorData.value
              }}
            </div>
          </div>
        }
      }
    </div>
  </div>

  <div
    class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.footer' | translate }}
  </div>
  <div class="px-4">
    <div class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary">
      @for (piePaginaData of piePagina; track piePaginaData) {
        @if (!piePaginaData.disguise) {
          <div
            class="flex flex-col gap-1"
            [ngClass]="{
              'col-span-full': piePaginaData.isHighlight,
            }"
          >
            <div class="font-bold">
              {{
                piePaginaData.replacementName ? piePaginaData.replacementName : piePaginaData.key
              }}:
            </div>
            {{
              piePaginaData.isMoney
                ? (piePaginaData.value | currency: 'MXN' : 'symbol' : '1.0-0')
                : piePaginaData.isPercentage
                  ? (piePaginaData.value * 100 | number: '1.0-2') + '%'
                  : piePaginaData.value
            }}
          </div>
        }
      }
    </div>
  </div>

  @for (accesorio of accesorios; track accesorio) {
    <div
      class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
    >
      {{ 'general-pages.summary.accessories' | translate }}
    </div>
    <div class="px-4">
      <div
        class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary"
      >
        @for (accesorioAux of accesorio; track accesorioAux) {
          @if (!accesorioAux.disguise) {
            <div
              class="flex flex-col gap-1"
              [ngClass]="{
                'col-span-full': accesorioAux.isHighlight,
              }"
            >
              <div class="font-bold">
                {{
                  accesorioAux.replacementName ? accesorioAux.replacementName : accesorioAux.key
                }}:
              </div>
              {{
                accesorioAux.isMoney
                  ? (accesorioAux.value | currency: 'MXN' : 'symbol' : '1.0-0')
                  : accesorioAux.isPercentage
                    ? (accesorioAux.value * 100 | number: '1.0-2') + '%'
                    : accesorioAux.value
              }}
            </div>
          }
        }
      </div>
    </div>
  }

  <div
    class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.accessories' | translate }}
  </div>
  @for (accesorio of accesorios; track accesorio) {
    <div class="px-4">
      <div
        class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary"
      >
        @for (dataAux of accesorio; track dataAux) {
          @if (!dataAux.disguise) {
            <div
              class="flex flex-col gap-1"
              [ngClass]="{
                'col-span-full': dataAux.isHighlight,
              }"
            >
              <div class="font-bold">
                {{ dataAux.replacementName ? dataAux.replacementName : dataAux.key }}:
              </div>
              {{
                dataAux.isMoney
                  ? (dataAux.value | currency: 'MXN' : 'symbol' : '1.0-0')
                  : dataAux.isPercentage
                    ? (dataAux.value * 100 | number: '1.0-2') + '%'
                    : dataAux.value
              }}
            </div>
          }
        }
        <div class="w-full col-span-full bg-[--brand-azul-primario] h-px"></div>
      </div>
    </div>
  }

  <div
    class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.guarantors' | translate }}
  </div>
  @for (avale of avales; track avale) {
    <div class="px-4">
      <div
        class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary"
      >
        @for (dataAux of avale; track dataAux) {
          @if (!dataAux.disguise) {
            <div
              class="flex flex-col gap-1"
              [ngClass]="{
                'col-span-full': dataAux.isHighlight,
              }"
            >
              <div class="font-bold">
                {{ dataAux.replacementName ? dataAux.replacementName : dataAux.key }}:
              </div>
              {{
                dataAux.isMoney
                  ? (dataAux.value | currency: 'MXN' : 'symbol' : '1.0-0')
                  : dataAux.isPercentage
                    ? (dataAux.value * 100 | number: '1.0-2') + '%'
                    : dataAux.value
              }}
            </div>
          }
        }
        <div class="w-full col-span-full bg-[--brand-azul-primario] h-px"></div>
      </div>
    </div>
  }

  <div
    class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.accessoriesDetail' | translate }}
  </div>
  @for (accesorios of accesoriosIntegraDetalle; track accesorios) {
    <div class="px-4">
      <div
        class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary"
      >
        @for (dataAux of accesorios; track dataAux) {
          @if (!dataAux.disguise) {
            <div
              class="flex flex-col gap-1"
              [ngClass]="{
                'col-span-full': dataAux.isHighlight,
              }"
            >
              <div class="font-bold">
                {{ dataAux.replacementName ? dataAux.replacementName : dataAux.key }}:
              </div>
              {{
                dataAux.isMoney
                  ? (dataAux.value | currency: 'MXN' : 'symbol' : '1.0-0')
                  : dataAux.isPercentage
                    ? (dataAux.value * 100 | number: '1.0-2') + '%'
                    : dataAux.value
              }}
            </div>
          }
        }
        <div class="w-full col-span-full bg-[--brand-azul-primario] h-px"></div>
      </div>
    </div>
  }

  <div
    class="px-4 py-2 text-general-subtitle text-(--color-text-primary) bg-[--brand-azul-primario] w-full rounded-lg text-center"
  >
    {{ 'general-pages.summary.procedures' | translate }}
  </div>
  @for (tramite of tramites; track tramite) {
    <div class="px-4">
      <div
        class="grid gap-3 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 text-general text-primary"
      >
        @for (dataAux of tramite; track dataAux) {
          @if (!dataAux.disguise) {
            <div
              class="flex flex-col gap-1"
              [ngClass]="{
                'col-span-full': dataAux.isHighlight,
              }"
            >
              <div class="font-bold">
                {{ dataAux.replacementName ? dataAux.replacementName : dataAux.key }}:
              </div>
              {{
                dataAux.isMoney
                  ? (dataAux.value | currency: 'MXN' : 'symbol' : '1.0-0')
                  : dataAux.isPercentage
                    ? (dataAux.value * 100 | number: '1.0-2') + '%'
                    : dataAux.value
              }}
            </div>
          }
        }
        <div class="w-full col-span-full bg-[--brand-azul-primario] h-px"></div>
      </div>
    </div>
  }
</div>

<app-load-general [load]="load"></app-load-general>
